import { BreadcrumbData, AppBreadcrumbs } from "@duosoftbg/nacid-components";

export const breadcrumbData: BreadcrumbData = [
  { path: "/", name: "t.page.homePage", isHomePage: true },
  { path: "/sitemap", name: "t.page.sitemap" },
  { path: "/contacts", name: "t.page.contacts" },
  { path: "/law", name: "t.page.law" },
  { path: "/personal-content", name: "t.header.personalContent" },
  { path: "/registration", name: "t.page.registration" },
  { path: "/feedback", name: "t.page.feedback" },
  { path: "/forgotten-password", name: "t.page.forgotten.password" },
  { path: "/forgotten-username", name: "t.page.forgotten.username" },
  { path: "/my-account", name: "t.page.my.account" },
  { path: "/admin-console", name: "t.page.admin.console" },
  { path: "/admin-console/sitemap", name: "t.page.sitemap.edit" },
  { path: "/admin-console/home-page-category", name: "t.page.homePageCategory.edit" },
  { path: "/admin-console/service-definitions", name: "t.page.serviceDefinitions.edit" },
  { path: "/admin-console/contacts", name: "t.page.contacts.edit" },
  { path: "/admin-console/law", name: "t.page.law.edit" },
  { path: "/admin-console/feedback", name: "t.page.feedback.admin" },
  { path: "/admin-console/global-message", name: "t.page.global.message.admin" },
  { path: "/admin-console/email/notifications", name: "t.page.email.notifications.admin" },
  { path: "/admin-console/email/templates", name: "t.page.email.templates.admin" },
  { path: "/admin-console/groups-roles", name: "t.page.groupsAndRoles.admin" },
  { path: "/admin-console/users", name: "t.page.users.admin" },
  { path: "/admin-console/users/edit", name: "t.page.user.admin.edit" },
  { path: "/admin-console/users/view", name: "t.page.user.admin.view" },
  { path: "/admin-console/config", name: "t.page.admin.console.config" },
  { path: "/admin-console/reference-data", name: "t.page.nomenclatures.reference.data" },
  { path: "/admin-console/national-university", name: "t.page.nomenclatures.national.university" },
  { path: "/admin-console/cache", name: "t.page.cache" },
  { path: "/qual-compare", name: "t.qualAssess" },
  {
    path: "/admin-console/getting-result-method",
    name: "t.page.nomenclatures.getting.result.method",
    isHomePage: false,
  },
];

const Breadcrumbs = () => {
  return <AppBreadcrumbs data={breadcrumbData} />;
};

export default Breadcrumbs;
